module.exports = __webpack_public_path__ + "media/images/signatures/maria_alejandra_estrada_arauz-d830560f9f22ea5ab83d455b8c258f4f.png";